exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-57aeacdc]{padding-top:0!important}i[data-v-57aeacdc]{color:#334e61;font-style:normal;display:block}.tab-content[data-v-57aeacdc]{display:block!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57aeacdc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Tabs.vue
// module id = 81
// module chunks = 0